import React, { Component } from 'react';
import { DLModal, LoadingOverlay } from 'appSrc/components/Shards';
import PickDate from './PickDate';
import style from './styles/style.module.css';


class RerunWizard extends Component {
    state = {
        fetching: false,
    }
    onFetching = () => {
        this.setState( { fetching: true } );
    }
    onSubmit = () => {
        this.setState( { fetching: false } );
        this.props.closeHandler( true );
    }


    render() {
        const { visible } = this.props;
        const { fetching } = this.state;

        return (
            <DLModal title='Re-Run Wizard' className={ style.wizard }
            visible={ visible }
            closeHandler={ this.props.closeHandler }>
                <div className={ style.main }>
                    { visible &&
                        <PickDate { ...this.props } onSubmit={ this.onSubmit } onFetching={ this.onFetching } />
                    }
                </div>
                { fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
RerunWizard.defaultProps = {
    visible: false,
    blocks: [],
};

export default RerunWizard;
